(() => {
  const rate = count => count >= 3 ? 20 : count >= 2 ? 10 : 0;
  const mode = item => /-FULL$/.test(item.sku || '') ? 'full' : /-START$/.test(item.sku || '') ? 'start' : null;
  const eligible = item => Boolean(mode(item));
  const quote = (start, full = 0) => {
    const count = start + full, percent = rate(count), factor = (100 - percent) / 100;
    return { count, percent, full: Math.round(count * 3900 * factor), paid: Math.round((start * 1000 + full * 3900) * factor), balance: Math.round(start * 2900 * factor), savings: Math.round(count * 3900 * (1 - factor)) };
  };
  const cartTotals = cart => {
    const lines = (cart.items || []).filter(eligible);
    const start = lines.filter(i => mode(i) === 'start').reduce((n,i) => n + i.quantity,0);
    const full = lines.filter(i => mode(i) === 'full').reduce((n,i) => n + i.quantity,0);
    const result = quote(start,full);
    const actualPaid = lines.reduce((n,i) => n + i.final_line_price,0);
    const valid = (!cart.currency || cart.currency === 'USD') && lines.every(i => i.original_price === (mode(i) === 'full' ? 3900 : 1000) && i.final_line_price === Math.round(i.original_price * i.quantity * (100-result.percent)/100));
    return {...result, actualPaid, valid, lines};
  };
  globalThis.PawtyPayment = Object.freeze({rate, mode, eligible, quote, cartTotals});
})();
